import { useSelector } from 'react-redux';
import { Image } from '@belong/ui';
import GeneralIcon, { GENERAL_ICONS } from 'components/GeneralIcon/GeneralIcon';
import { selectSettings } from 'store/redux/settings';

export const AutoSplitNotice = ({
  improvementsReport = false,
}: {
  improvementsReport?: boolean;
}) => {
  const settings = useSelector(selectSettings);
  const interestRateValue =
    settings?.commerceSettings?.splitItSettings?.interestRateValue;
  return (
    <div className="mb-2xl mt-sm rounded border border-solid border-green bg-green-translucent-light p-sm">
      <div className="mb-sm flex flex-col items-center sm:flex-row">
        <Image
          src="homeowner-earnings/split-it-badge.svg"
          alt="Split It"
          className="h-[36px] w-[83px]"
        />
        <div className="mt-sm sm:ml-sm sm:mt-0 sm:flex-1">
          <p className="text-center text-p1 font-semibold sm:text-left md:text-body">
            Introducing Split It
          </p>
          <p className="text-center text-p1 leading-p2 sm:text-left">
            Split purchases instantly into monthly installments.
          </p>
        </div>
      </div>

      {autoSplitContent(interestRateValue, improvementsReport).map(
        (bullet, index) => (
          <div className="mb-[14px] flex flex-nowrap items-start" key={index}>
            <GeneralIcon
              icon={GENERAL_ICONS.CHECKMARK}
              color="green"
              className="mr-[16px] mt-2xs"
            />
            <p className="flex-1 font-semibold">{bullet}</p>
          </div>
        ),
      )}
    </div>
  );
};

const autoSplitContent = (value?: number, improvementsReport?: boolean) => [
  ...(improvementsReport
    ? ['Up To 12 Monthly Installments', 'Deducted From Rent When Available']
    : ['Deducted From Rent Over The Course Of Your Lease']),
  'No Credit Check Required',
  'Simpler Than A Home Equity Line Of Credit',

  `Lower Interest Than Your Credit Card (${value}% APR)`,
  'Close Out At Anytime With No Additional Fees',
  'Smoother Monthly Earnings',
];
